import Table from './Table.view';
export default Table;
